import React from 'react';
import { Link } from 'react-router-dom';
import './Cards4.css';

function Cards4() {
  return (
    <section className="cards4">
      <h1 className="cards4-title">AGENCIAS DE APOYO</h1>
      <p className="cards4-subtitle">HWASA aprecia el apoyo de las siguientes instituciones</p>

      <div className="cards4-logos">
        <Link
          to="https://mccsa.org.au/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="MCCSA"
          className="logo-link"
        >
          <img src="/images/MCCSA-Logo.png" alt="MCCSA Logo" className="logo-img" loading="lazy" />
        </Link>

        <Link
          to="https://purpleorange.org.au/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Purple Orange"
          className="logo-link"
        >
          <img src="/images/orange-logo.png" alt="Purple Orange Logo" className="logo-img" loading="lazy" />
        </Link>
      </div>
    </section>
  );
}

export default Cards4;